import { Component } from '@angular/core';

@Component({
  selector: 'page-content-header',
  templateUrl: './page-content-header.component.html',
})
export class PageContentHeaderComponent {}
